<template>
    <div class="modal-popup" v-if="display">
        <div class="popup" ref="modalPopup">
            <h4>{{ title }}</h4>
            <p v-html="subtitle"></p>
            
             <div class="buttons">
                <div class="button btn-outline-primary cancel" @click="cancelModal" v-if="textCancel.length">
                    {{ textCancel }}
                </div>

                <div class="button btn-primary valid" @click="validModal" v-if="textValid.length">
                    {{ textValid }}
                </div>
               
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {    

        data() {
            return {
                display: false,

                eventNameValid: null,
                eventNameCancel: null,
                textValid: '',
                textCancel: '',

                title:'',
                subtitle:'',
                params: null
                
            }
        },

        mounted(){
            EventBus.$on('showModal', this.showModal);
        },

        methods: {
            showModal(title,subtitle,textBtnValid,textBtnCancel,actionValid,actionCancel,params) {
                this.title = title || '';
                this.subtitle = subtitle || '';
                this.textValid = textBtnValid || '',
                this.textCancel = textBtnCancel || '',
                this.eventNameValid = actionValid || null;
                this.eventNameCancel = actionCancel || null;
                this.params = params || null
                this.display = true
            },

            validModal() {
                if (this.eventNameValid) EventBus.$emit(this.eventNameValid,this.params);
                this.resetData()
            },

            cancelModal() {
                if (this.eventNameCancel) EventBus.$emit(this.eventNameCancel,this.params);
                this.resetData()
            },

            resetData() {
                this.display = false;
                this.eventNameValid = null;
                this.eventNameCancel= null;
                this.title = '';
                this.subtitle = '';
               
            },

            handleClickOutside(event) {
                const targetElement = this.$refs.modalPopup;
                if (!targetElement.contains(event.target)) {
                    this.resetData()
                }
            },
        },

        watch : {
            display() {
                if (this.display) {   
                    window.addEventListener('click', this.handleClickOutside);
                }else{
                    window.removeEventListener("click", this.handleClickOutside, false);
                }
            }
        },

        beforeDestroy() {
            EventBus.$off('showModal', this.showModal);
            window.removeEventListener("click", this.handleClickOutside);
        },
            
    }
</script>
